import { LangStrings } from './types'

// Estonian language strings (default)
const etLang: LangStrings = {
    timer_label: 'Sessioon aegub',
    session_expired: 'Teie sessioon aegus',
    floorplan_screen: 'Ekraan',
    floorplan_entry: 'sissepääs',
    floorplan_stage: 'Lava',
    floorplan_balcony: 'rõdu',
    floorplan_sideBalcony: 'külgrõdu',
    intro_freeSeats: 'Vabu kohti',
    tickets_title: 'Vali piletid',
    tickets_max: 'Vabandage, maksimaalne piletite arv on ületatud',
    tickets_serialTicket: 'Seeriapilet {number}',
    tickets_giftCard: 'Kinkekaart {number}',
    tickets_amountLeft: 'Jääk',
    tickets_total: 'Kokku',
    products_title: 'Valitud tooted',
    cart_title: 'Ostukorv',
    cards_title: 'Kliendikaardid ja kinkekaardid',
    cards_label: 'kliendikaardi või kinkekaardi nr',
    cards_button: 'Kinnita nr',
    cards_notFound: 'Sellise numbriga kaarti kahjuks ei leitud',
    cards_alreadyAdded: 'See kaart on juba lisatud sellele sessioonile',
    cards_notApplicable: 'See soodustus ei kehti sellel tellimusel',
    contact_title: 'Andmed',
    contact_description:
        'Palun sisesta enda kontakt, et saaksime sulle e-postiga pileti saata ning ootamatus olukorras ühendust võtta.',
    contact_name: 'nimi',
    contact_name_invalid: 'Palun sisestage nimi',
    contact_email: 'e-post',
    contact_email_invalid: 'Palun sisestage korrektne email',
    contact_email_card_mismatch:
        'Sisestatud e-posti aadress ei kattu kliendikaardi e-posti addressiga',
    contact_phone: 'telefon',
    contact_newsletter: 'Soovin liituda kino uudiskirjaga',
    terms: 'Ostes nõustun kasutajatingimuste ja privaatsuspoliitikaga.',
    banks_title: 'Vali pank',
    banks_paymentFailed: 'Makse ebaõnnestus, palun proovige uuesti',
    banks_required: 'Palun valige sobiv pank',
    error_title: 'Oih, midagi läks valesti!',
    submit_register: 'Registreeri',
    submit_pay: 'Alusta maksmist',
    schedule: 'Kinokava',
    completed_title: 'Ost õnnestus!',
    completed_startNew: 'Alusta uut ostu',
    soldOut_title: 'Välja müüdud',
    soldOut_text: 'Vabandame, seanss on välja müüdud.',
    temporarilyUnavailable_title: 'Vabandame, piletid ei ole hetkel saadaval.',
    pending_title: 'Makse on veel pooleli',
    pending_text: 'Palun lõpetage makse, siis suunatakse teid õigesse vaatesse.',
    sale_expired: 'Piletimüük on lõppenud',
    giftCard_amountPresets_text: 'Palun vali, mitu kinokülastust võiks selle kinkekaardiga teha.',
    giftCard_oneTicket: 'Üks pilet (€ {price})',
    giftCard_twoTickets: 'Kaks piletit (€ {price})',
    giftCard_sixTickets: 'Kuus piletit (€ {price})',
    giftCard_tenTickets: '10 piletit (€ {price})',
    giftCard_customAmount: 'Või sisesta ise vabalt valitud summa lahtrisse.',
    giftCard_amount_invalid: 'Palun sisestage korrektne summa',
    giftCard_amount_min:
        'Kinkekaardi maksumus peab olema vähemalt {min} €. Palun vali suurem summa.',
    giftCard_amount_max:
        'Kahjuks nii kallist kinkekaarti läbi kodulehe osta ei saa. Soovi korral võta palun ühendust kinoga ja leiame lahenduse.',
    giftCard_email_label: 'Sinu e-mail',
    giftCard_completed_title: 'Kinkekaart on ostetud!',
    giftCard_code: 'Sinu kinkekaardi kood on:',
    giftCard_usage: 'Seda saad kasutada nii kino koduleheküljel kui kassas.',
    serialTicket_type_label: 'Seeriapileti tüüp',
    serialTicket_type_uses: '{count} kasutuskorda',
    serialTicket_type_expires: 'Kehtib kuni {date}',
    serialTicket_email_label: 'Sinu e-mail',
    serialTicket_completed_title: 'Seeriapilet on ostetud!',
    serialTicket_code: 'Sinu seeriapileti kood on:',
    serialTicket_usage: 'Seda saad kasutada nii kino koduleheküljel kui kassas.',
    serialTicket_amountLeft_multiple: 'Alles jääb {number} piletit',
    serialTicket_amountLeft_singular: 'Alles jääb 1 pilet',
    progressBar_tickets: 'Piletid',
    progressBar_products: 'Tooted',
    progressBar_summary: 'Kinnita ja maksa',
    chooseProducts: 'Vali tooted ja maksa',
    completePurchase: 'Vormista ost ja maksa',
    back: 'Tagasi',
    allProducts: 'Kõik tooted',
    searchProduct: 'Otsi toodet...',
    uncategorizedProducts: 'Muud tooted',
    myTickets: 'Minu piletid',
    change: 'Muuda',
    products_noResults: 'Otsingule ei vastanud ükski tulemus.',
    products_tryAnotherSearch: 'Proovi teist otsingusõna või',
    products_removeFilters: 'kustuta filtrid',
    products_disabled: 'Toodete tellimine on hetkel välja lülitatud.',
    products_total: 'Kokku',
    products_sidebar_title: 'Toodete tellimine',
    products_sidebar_firstParagraph: 'Telli enda istekohale toit ja jook valmis!',
    products_sidebar_textBeforeLink: 'Kui sul pole veel pilet ostetud, siis vaata meie ',
    products_sidebar_linkText: 'kinokava',
    products_sidebar_textAfterLink: '.',
    eventSelection_chooseEventTitle: 'Vali ostetud pileti seanss',
    eventSelection_chooseSeatTitle: 'Vali ostetud pileti istekoht',
    eventSelection_chooseProduction: 'Vali film',
    eventSelection_chooseEvent: 'Vali seanss',
    eventSelection_chooseRow: 'Vali rida',
    eventSelection_chooseSeat: 'Vali istekoht',
    eventSelection_noNumberedSeats:
        'Antud seansil ei ole nummerdatud istekohti. Tellitud tooted seostatakse tellija nimega.',
    row: 'Rida',
    seat: 'Koht',
    cartEmpty: 'Ostukorv on tühi. Tellimuse esitamiseks lisa mõni toode ostukorvi.',
}

// Latvian language strings (lv)
const lvLang: LangStrings = {
    timer_label: 'Sesija beidzas',
    session_expired: 'Jūsu sesija ir beigusies',
    floorplan_screen: 'Ekrāns',
    floorplan_entry: 'ieeja',
    floorplan_stage: 'Skatuve',
    floorplan_balcony: 'balkons',
    floorplan_sideBalcony: 'sānu balkons',
    intro_freeSeats: 'Brīvas vietas',
    tickets_title: 'Izvēlieties biļetes',
    tickets_max: 'Atvainojiet, ir pārsniegts maksimālais biļešu skaits',
    tickets_serialTicket: 'Sērijas biļete {number}',
    tickets_giftCard: 'Dāvanu karte {number}',
    tickets_amountLeft: 'Atlikums',
    tickets_total: 'Kopā',
    products_title: 'Izvēlētie produkti',
    cart_title: 'Grozs',
    cards_title: 'Klienta kartes un dāvanu kartes',
    cards_label: 'klienta kartes vai dāvanu kartes nr',
    cards_button: 'Apstiprināt numuru',
    cards_notFound: 'Diemžēl karte ar šādu numuru nav atrasta',
    cards_alreadyAdded: 'Šī karte jau ir pievienota šai sesijai',
    cards_notApplicable: 'Šī atlaide nav piemērojama šim pasūtījumam',
    contact_title: 'Informācija',
    contact_description:
        'Lūdzu ievadiet savu kontaktinformāciju, lai mēs varētu nosūtīt jums biļeti e-pastā un sazināties neparedzētos gadījumos.',
    contact_name: 'vārds',
    contact_name_invalid: 'Lūdzu, ievadiet vārdu',
    contact_email: 'e-pasts',
    contact_email_invalid: 'Lūdzu, ievadiet derīgu e-pasta adresi',
    contact_email_card_mismatch: 'Ievadītā e-pasta adrese neatbilst klienta kartes e-pasta adresei',
    contact_phone: 'tālrunis',
    contact_newsletter: 'Vēlos abonēt kino jaunumus',
    terms: 'Pērkot, es piekrītu lietošanas noteikumiem un privātuma politikai.',
    banks_title: 'Izvēlieties banku',
    banks_paymentFailed: 'Maksājums neizdevās, lūdzu, mēģiniet vēlreiz',
    banks_required: 'Lūdzu, izvēlieties piemērotu banku',
    error_title: 'Ups, kaut kas nogāja greizi!',
    submit_register: 'Reģistrēties',
    submit_pay: 'Sākt maksāt',
    schedule: 'Kino programma',
    completed_title: 'Pirkums veiksmīgs!',
    completed_startNew: 'Sākt jaunu pirkumu',
    soldOut_title: 'Izpārdots',
    soldOut_text: 'Atvainojamies, seanss ir izpārdots.',
    temporarilyUnavailable_title: 'Atvainojamies, biļetes pašlaik nav pieejamas.',
    pending_title: 'Maksājums joprojām ir process',
    pending_text: 'Lūdzu, pabeidziet maksājumu, tad jūs tiksiet novirzīts uz pareizo skatu.',
    sale_expired: 'Biļešu tirdzniecība ir beigusies',
    giftCard_amountPresets_text:
        'Lūdzu, izvēlieties, cik kino apmeklējumus varētu veikt ar šo dāvanu karti.',
    giftCard_oneTicket: 'Viena biļete (€ {price})',
    giftCard_twoTickets: 'Divas biļetes (€ {price})',
    giftCard_sixTickets: 'Sešas biļetes (€ {price})',
    giftCard_tenTickets: '10 biļetes (€ {price})',
    giftCard_customAmount: 'Vai ievadiet brīvi izvēlētu summu laukā.',
    giftCard_amount_invalid: 'Lūdzu, ievadiet derīgu summu',
    giftCard_amount_min:
        'Dāvanu kartes vērtībai jābūt vismaz {min} €. Lūdzu, izvēlieties lielāku summu.',
    giftCard_amount_max:
        'Diemžēl tik dārgu dāvanu karti nevar iegādāties caur mājas lapu. Ja vēlaties, lūdzu, sazinieties ar kino, un mēs atradīsim risinājumu.',
    giftCard_email_label: 'Jūsu e-pasts',
    giftCard_completed_title: 'Dāvanu karte ir nopirkta!',
    giftCard_code: 'Jūsu dāvanu kartes kods ir:',
    giftCard_usage: 'To var izmantot gan kino mājas lapā, gan kasē.',
    serialTicket_type_label: 'Sērijas biļetes veids',
    serialTicket_type_uses: '{count} lietošanas reizes',
    serialTicket_type_expires: 'Derīga līdz {date}',
    serialTicket_email_label: 'Jūsu e-pasts',
    serialTicket_completed_title: 'Sērijas biļete ir nopirkta!',
    serialTicket_code: 'Jūsu sērijas biļetes kods ir:',
    serialTicket_usage: 'To var izmantot gan kino mājas lapā, gan kasē.',
    serialTicket_amountLeft_multiple: 'Paliek {number} biļetes',
    serialTicket_amountLeft_singular: 'Paliek 1 biļete',
    progressBar_tickets: 'Biļetes',
    progressBar_products: 'Produkti',
    progressBar_summary: 'Apstiprināt un maksāt',
    chooseProducts: 'Izvēlieties produktus un maksājiet',
    completePurchase: 'Pabeigt pirkumu un maksāt',
    back: 'Atpakaļ',
    allProducts: 'Visi produkti',
    searchProduct: 'Meklēt produktu...',
    uncategorizedProducts: 'Citi produkti',
    myTickets: 'Manas biļetes',
    change: 'Mainīt',
    products_noResults: 'Meklēšanai neatbilst neviens rezultāts.',
    products_tryAnotherSearch: 'Izmēģiniet citu meklēšanas vārdu vai',
    products_removeFilters: 'notīriet filtrus',
    products_disabled: 'Produktu pasūtīšana pašlaik ir izslēgta.',
    products_total: 'Kopā',
    products_sidebar_title: 'Produktu pasūtīšana',
    products_sidebar_firstParagraph: 'Pasūtiet ēdienu un dzērienu savai sēdvietai!',
    products_sidebar_textBeforeLink: 'Ja jums vēl nav biļetes, skatiet mūsu ',
    products_sidebar_linkText: 'kino programmu',
    products_sidebar_textAfterLink: '.',
    eventSelection_chooseEventTitle: 'Izvēlieties seansa biļeti',
    eventSelection_chooseSeatTitle: 'Izvēlieties nopirktās biļetes sēdvietu',
    eventSelection_chooseProduction: 'Izvēlieties filmu',
    eventSelection_chooseEvent: 'Izvēlieties seansu',
    eventSelection_chooseRow: 'Izvēlieties rindu',
    eventSelection_chooseSeat: 'Izvēlieties sēdvietu',
    eventSelection_noNumberedSeats:
        'Šajā seansā nav numurētu sēdvietu. Pasūtītie produkti tiks saistīti ar pasūtītāja vārdu.',
    row: 'Rinda',
    seat: 'Vieta',
    cartEmpty: 'Grozs ir tukšs. Lai iesniegtu pasūtījumu, pievienojiet grozam kādu produktu.',
}

// English language strings (en)
const enLang: LangStrings = {
    timer_label: 'Session expires',
    session_expired: 'Your session has expired',
    floorplan_screen: 'Screen',
    floorplan_entry: 'entrance',
    floorplan_stage: 'Stage',
    floorplan_balcony: 'balcony',
    floorplan_sideBalcony: 'side balcony',
    intro_freeSeats: 'Free seats',
    tickets_title: 'Select tickets',
    tickets_max: 'Sorry, the maximum number of tickets has been exceeded',
    tickets_serialTicket: 'Serial ticket {number}',
    tickets_giftCard: 'Gift card {number}',
    tickets_amountLeft: 'Balance',
    tickets_total: 'Total',
    products_title: 'Selected products',
    cart_title: 'Cart',
    cards_title: 'Customer cards and gift cards',
    cards_label: 'customer card or gift card number',
    cards_button: 'Confirm number',
    cards_notFound: 'Unfortunately, a card with this number was not found',
    cards_alreadyAdded: 'This card has already been added to this session',
    cards_notApplicable: 'This discount is not applicable to this order',
    contact_title: 'Information',
    contact_description:
        'Please enter your contact information so we can send you the ticket by email and contact you in an unexpected situation.',
    contact_name: 'name',
    contact_name_invalid: 'Please enter your name',
    contact_email: 'email',
    contact_email_invalid: 'Please enter a valid email',
    contact_email_card_mismatch:
        'The entered email address does not match the customer card email address',
    contact_phone: 'phone',
    contact_newsletter: 'I want to subscribe to cinema news',
    terms: 'By purchasing, I agree to the terms of use and privacy policy.',
    banks_title: 'Select bank',
    banks_paymentFailed: 'Payment failed, please try again',
    banks_required: 'Please select an appropriate bank',
    error_title: 'Oops, something went wrong!',
    submit_register: 'Register',
    submit_pay: 'Start payment',
    schedule: 'Cinema schedule',
    completed_title: 'Purchase successful!',
    completed_startNew: 'Start a new purchase',
    soldOut_title: 'Sold out',
    soldOut_text: 'Sorry, the session is sold out.',
    temporarilyUnavailable_title: 'Sorry, tickets are currently unavailable.',
    pending_title: 'Payment is still in progress',
    pending_text: 'Please complete the payment, then you will be redirected to the correct view.',
    sale_expired: 'Ticket sales have ended',
    giftCard_amountPresets_text:
        'Please select how many cinema visits could be made with this gift card.',
    giftCard_oneTicket: 'One ticket (€ {price})',
    giftCard_twoTickets: 'Two tickets (€ {price})',
    giftCard_sixTickets: 'Six tickets (€ {price})',
    giftCard_tenTickets: '10 tickets (€ {price})',
    giftCard_customAmount: 'Or enter a freely chosen amount in the field.',
    giftCard_amount_invalid: 'Please enter a valid amount',
    giftCard_amount_min:
        'The gift card value must be at least {min} €. Please select a larger amount.',
    giftCard_amount_max:
        'Unfortunately, such an expensive gift card cannot be purchased through the website. If you wish, please contact the cinema and we will find a solution.',
    giftCard_email_label: 'Your email',
    giftCard_completed_title: 'Gift card has been purchased!',
    giftCard_code: 'Your gift card code is:',
    giftCard_usage: 'It can be used both on the cinema website and at the box office.',
    serialTicket_type_label: 'Serial ticket type',
    serialTicket_type_uses: '{count} uses',
    serialTicket_type_expires: 'Valid until {date}',
    serialTicket_email_label: 'Your email',
    serialTicket_completed_title: 'Serial ticket has been purchased!',
    serialTicket_code: 'Your serial ticket code is:',
    serialTicket_usage: 'It can be used both on the cinema website and at the box office.',
    serialTicket_amountLeft_multiple: '{number} tickets left',
    serialTicket_amountLeft_singular: '1 ticket left',
    progressBar_tickets: 'Tickets',
    progressBar_products: 'Products',
    progressBar_summary: 'Confirm and pay',
    chooseProducts: 'Choose products and pay',
    completePurchase: 'Complete purchase and pay',
    back: 'Back',
    allProducts: 'All products',
    searchProduct: 'Search product...',
    uncategorizedProducts: 'Other products',
    myTickets: 'My tickets',
    change: 'Change',
    products_noResults: 'No results match your search.',
    products_tryAnotherSearch: 'Try another search term or',
    products_removeFilters: 'clear filters',
    products_disabled: 'Product ordering is currently turned off.',
    products_total: 'Total',
    products_sidebar_title: 'Product ordering',
    products_sidebar_firstParagraph: 'Order food and drink for your seat!',
    products_sidebar_textBeforeLink: 'If you do not have a ticket yet, see our ',
    products_sidebar_linkText: 'cinema schedule',
    products_sidebar_textAfterLink: '.',
    eventSelection_chooseEventTitle: 'Select your purchased ticket session',
    eventSelection_chooseSeatTitle: 'Select your purchased ticket seat',
    eventSelection_chooseProduction: 'Select movie',
    eventSelection_chooseEvent: 'Select session',
    eventSelection_chooseRow: 'Select row',
    eventSelection_chooseSeat: 'Select seat',
    eventSelection_noNumberedSeats:
        "This session does not have numbered seats. Ordered products will be associated with the orderer's name.",
    row: 'Row',
    seat: 'Seat',
    cartEmpty: 'The cart is empty. To submit an order, add a product to the cart.',
}

// Finnish language strings (fi)
const fiLang: LangStrings = {
    timer_label: 'Istunto päättyy',
    session_expired: 'Istuntosi on päättynyt',
    floorplan_screen: 'Valkokangas',
    floorplan_entry: 'sisäänkäynti',
    floorplan_stage: 'Lava',
    floorplan_balcony: 'parveke',
    floorplan_sideBalcony: 'sivuparveke',
    intro_freeSeats: 'Vapaat paikat',
    tickets_title: 'Valitse liput',
    tickets_max: 'Valitettavasti lippujen enimmäismäärä on ylitetty',
    tickets_serialTicket: 'Sarjalippu {number}',
    tickets_giftCard: 'Lahjakortti {number}',
    tickets_amountLeft: 'Saldo',
    tickets_total: 'Yhteensä',
    products_title: 'Valitut tuotteet',
    cart_title: 'Ostoskori',
    cards_title: 'Asiakaskortit ja lahjakortit',
    cards_label: 'asiakaskortin tai lahjakortin numero',
    cards_button: 'Vahvista numero',
    cards_notFound: 'Valitettavasti tällä numerolla olevaa korttia ei löytynyt',
    cards_alreadyAdded: 'Tämä kortti on jo lisätty tähän istuntoon',
    cards_notApplicable: 'Tämä alennus ei koske tätä tilausta',
    contact_title: 'Tiedot',
    contact_description:
        'Syötä yhteystietosi, jotta voimme lähettää sinulle lipun sähköpostitse ja ottaa yhteyttä odottamattomassa tilanteessa.',
    contact_name: 'nimi',
    contact_name_invalid: 'Ole hyvä ja syötä nimesi',
    contact_email: 'sähköposti',
    contact_email_invalid: 'Ole hyvä ja syötä oikea sähköpostiosoite',
    contact_email_card_mismatch:
        'Annettu sähköpostiosoite ei vastaa asiakaskortin sähköpostiosoitetta',
    contact_phone: 'puhelin',
    contact_newsletter: 'Haluan liittyä elokuvateatterin uutiskirjeeseen',
    terms: 'Ostamalla hyväksyn käyttöehdot ja tietosuojakäytännön.',
    banks_title: 'Valitse pankki',
    banks_paymentFailed: 'Maksu epäonnistui, yritä uudelleen',
    banks_required: 'Valitse sopiva pankki',
    error_title: 'Hups, jokin meni pieleen!',
    submit_register: 'Rekisteröidy',
    submit_pay: 'Aloita maksaminen',
    schedule: 'Elokuvaohjelmisto',
    completed_title: 'Ostos onnistui!',
    completed_startNew: 'Aloita uusi ostos',
    soldOut_title: 'Loppuunmyyty',
    soldOut_text: 'Valitettavasti näytös on loppuunmyyty.',
    temporarilyUnavailable_title: 'Valitettavasti liput eivät ole tällä hetkellä saatavilla.',
    pending_title: 'Maksu on edelleen kesken',
    pending_text: 'Ole hyvä ja suorita maksu loppuun, sitten sinut ohjataan oikeaan näkymään.',
    sale_expired: 'Lippujen myynti on päättynyt',
    giftCard_amountPresets_text:
        'Valitse, kuinka monta elokuvakäyntiä tällä lahjakortilla voisi tehdä.',
    giftCard_oneTicket: 'Yksi lippu (€ {price})',
    giftCard_twoTickets: 'Kaksi lippua (€ {price})',
    giftCard_sixTickets: 'Kuusi lippua (€ {price})',
    giftCard_tenTickets: '10 lippua (€ {price})',
    giftCard_customAmount: 'Tai syötä itse valitsemasi summa kenttään.',
    giftCard_amount_invalid: 'Ole hyvä ja syötä kelvollinen summa',
    giftCard_amount_min:
        'Lahjakortin arvon on oltava vähintään {min} €. Ole hyvä ja valitse suurempi summa.',
    giftCard_amount_max:
        'Valitettavasti näin kallista lahjakorttia ei voi ostaa verkkosivun kautta. Jos haluat, ota yhteyttä elokuvateatteriin, niin löydämme ratkaisun.',
    giftCard_email_label: 'Sähköpostisi',
    giftCard_completed_title: 'Lahjakortti on ostettu!',
    giftCard_code: 'Lahjakorttisi koodi on:',
    giftCard_usage: 'Voit käyttää sitä sekä elokuvateatterin verkkosivuilla että kassalla.',
    serialTicket_type_label: 'Sarjalipun tyyppi',
    serialTicket_type_uses: '{count} käyttökertaa',
    serialTicket_type_expires: 'Voimassa {date} asti',
    serialTicket_email_label: 'Sähköpostisi',
    serialTicket_completed_title: 'Sarjalippu on ostettu!',
    serialTicket_code: 'Sarjalippusi koodi on:',
    serialTicket_usage: 'Voit käyttää sitä sekä elokuvateatterin verkkosivuilla että kassalla.',
    serialTicket_amountLeft_multiple: 'Jäljellä {number} lippua',
    serialTicket_amountLeft_singular: 'Jäljellä 1 lippu',
    progressBar_tickets: 'Liput',
    progressBar_products: 'Tuotteet',
    progressBar_summary: 'Vahvista ja maksa',
    chooseProducts: 'Valitse tuotteet ja maksa',
    completePurchase: 'Viimeistele ostos ja maksa',
    back: 'Takaisin',
    allProducts: 'Kaikki tuotteet',
    searchProduct: 'Etsi tuotetta...',
    uncategorizedProducts: 'Muut tuotteet',
    myTickets: 'Lippuni',
    change: 'Muuta',
    products_noResults: 'Hakua ei vastannut yksikään tulos.',
    products_tryAnotherSearch: 'Kokeile toista hakusanaa tai',
    products_removeFilters: 'poista suodattimet',
    products_disabled: 'Tuotteiden tilaaminen on tällä hetkellä pois käytöstä.',
    products_total: 'Yhteensä',
    products_sidebar_title: 'Tuotteiden tilaaminen',
    products_sidebar_firstParagraph: 'Tilaa ruoka ja juoma valmiiksi istumapaikallesi!',
    products_sidebar_textBeforeLink: 'Jos sinulla ei ole vielä lippua, katso meidän ',
    products_sidebar_linkText: 'elokuvaohjelmistoa',
    products_sidebar_textAfterLink: '.',
    eventSelection_chooseEventTitle: 'Valitse ostetun lipun näytös',
    eventSelection_chooseSeatTitle: 'Valitse ostetun lipun istumapaikka',
    eventSelection_chooseProduction: 'Valitse elokuva',
    eventSelection_chooseEvent: 'Valitse näytös',
    eventSelection_chooseRow: 'Valitse rivi',
    eventSelection_chooseSeat: 'Valitse istumapaikka',
    eventSelection_noNumberedSeats:
        'Tässä näytöksessä ei ole numeroituja istumapaikkoja. Tilatut tuotteet yhdistetään tilaajan nimeen.',
    row: 'Rivi',
    seat: 'Paikka',
    cartEmpty: 'Ostoskori on tyhjä. Lisää ostoskoriin jokin tuote jatkaaksesi tilausta.',
}

// Lithuanian language strings (lt)
const ltLang: LangStrings = {
    timer_label: 'Sesija baigiasi',
    session_expired: 'Jūsų sesija baigėsi',
    floorplan_screen: 'Ekranas',
    floorplan_entry: 'įėjimas',
    floorplan_stage: 'Scena',
    floorplan_balcony: 'balkonas',
    floorplan_sideBalcony: 'šoninis balkonas',
    intro_freeSeats: 'Laisvos vietos',
    tickets_title: 'Pasirinkite bilietus',
    tickets_max: 'Atsiprašome, viršytas maksimalus bilietų skaičius',
    tickets_serialTicket: 'Serijinis bilietas {number}',
    tickets_giftCard: 'Dovanų kortelė {number}',
    tickets_amountLeft: 'Likutis',
    tickets_total: 'Iš viso',
    products_title: 'Pasirinkti produktai',
    cart_title: 'Krepšelis',
    cards_title: 'Kliento kortelės ir dovanų kortelės',
    cards_label: 'kliento kortelės arba dovanų kortelės numeris',
    cards_button: 'Patvirtinti numerį',
    cards_notFound: 'Deja, kortelė su šiuo numeriu nerasta',
    cards_alreadyAdded: 'Ši kortelė jau pridėta prie šios sesijos',
    cards_notApplicable: 'Ši nuolaida netaikoma šiam užsakymui',
    contact_title: 'Informacija',
    contact_description:
        'Įveskite savo kontaktinę informaciją, kad galėtume jums išsiųsti bilietą el. paštu ir susisiekti netikėtoje situacijoje.',
    contact_name: 'vardas',
    contact_name_invalid: 'Prašome įvesti savo vardą',
    contact_email: 'el. paštas',
    contact_email_invalid: 'Prašome įvesti teisingą el. paštą',
    contact_email_card_mismatch:
        'Įvestas el. pašto adresas nesutampa su kliento kortelės el. pašto adresu',
    contact_phone: 'telefonas',
    contact_newsletter: 'Noriu prenumeruoti kino teatro naujienas',
    terms: 'Pirkdamas sutinku su naudojimo sąlygomis ir privatumo politika.',
    banks_title: 'Pasirinkite banką',
    banks_paymentFailed: 'Mokėjimas nepavyko, bandykite dar kartą',
    banks_required: 'Prašome pasirinkti tinkamą banką',
    error_title: 'Oi, kažkas nepavyko!',
    submit_register: 'Registruotis',
    submit_pay: 'Pradėti mokėjimą',
    schedule: 'Kino repertuaras',
    completed_title: 'Pirkimas sėkmingas!',
    completed_startNew: 'Pradėti naują pirkimą',
    soldOut_title: 'Išparduota',
    soldOut_text: 'Atsiprašome, seansas išparduotas.',
    temporarilyUnavailable_title: 'Atsiprašome, bilietai šiuo metu nepasiekiami.',
    pending_title: 'Mokėjimas vis dar vyksta',
    pending_text: 'Prašome užbaigti mokėjimą, tada būsite nukreipti į teisingą vaizdą.',
    sale_expired: 'Bilietų pardavimas baigėsi',
    giftCard_amountPresets_text:
        'Prašome pasirinkti, kiek kino apsilankymų galėtų būti atlikta su šia dovanų kortele.',
    giftCard_oneTicket: 'Vienas bilietas (€ {price})',
    giftCard_twoTickets: 'Du bilietai (€ {price})',
    giftCard_sixTickets: 'Šeši bilietai (€ {price})',
    giftCard_tenTickets: '10 bilietų (€ {price})',
    giftCard_customAmount: 'Arba įveskite laisvai pasirinktą sumą į lauką.',
    giftCard_amount_invalid: 'Prašome įvesti teisingą sumą',
    giftCard_amount_min:
        'Dovanų kortelės vertė turi būti bent {min} €. Prašome pasirinkti didesnę sumą.',
    giftCard_amount_max:
        'Deja, tokios brangios dovanų kortelės per tinklalapį įsigyti negalima. Jei norite, susisiekite su kino teatru ir rasime sprendimą.',
    giftCard_email_label: 'Jūsų el. paštas',
    giftCard_completed_title: 'Dovanų kortelė nupirkta!',
    giftCard_code: 'Jūsų dovanų kortelės kodas yra:',
    giftCard_usage: 'Ją galite naudoti tiek kino teatro tinklalapyje, tiek kasoje.',
    serialTicket_type_label: 'Serijinio bilieto tipas',
    serialTicket_type_uses: '{count} naudojimo kartai',
    serialTicket_type_expires: 'Galioja iki {date}',
    serialTicket_email_label: 'Jūsų el. paštas',
    serialTicket_completed_title: 'Serijinis bilietas nupirktas!',
    serialTicket_code: 'Jūsų serijinio bilieto kodas yra:',
    serialTicket_usage: 'Jį galite naudoti tiek kino teatro tinklalapyje, tiek kasoje.',
    serialTicket_amountLeft_multiple: 'Liko {number} bilietai',
    serialTicket_amountLeft_singular: 'Liko 1 bilietas',
    progressBar_tickets: 'Bilietai',
    progressBar_products: 'Produktai',
    progressBar_summary: 'Patvirtinti ir mokėti',
    chooseProducts: 'Pasirinkite produktus ir mokėkite',
    completePurchase: 'Užbaigti pirkimą ir mokėti',
    back: 'Atgal',
    allProducts: 'Visi produktai',
    searchProduct: 'Ieškoti produkto...',
    uncategorizedProducts: 'Kiti produktai',
    myTickets: 'Mano bilietai',
    change: 'Keisti',
    products_noResults: 'Nėra rezultatų, atitinkančių jūsų paiešką.',
    products_tryAnotherSearch: 'Pabandykite kitą paieškos žodį arba',
    products_removeFilters: 'išvalykite filtrus',
    products_disabled: 'Produktų užsakymas šiuo metu išjungtas.',
    products_total: 'Iš viso',
    products_sidebar_title: 'Produktų užsakymas',
    products_sidebar_firstParagraph: 'Užsisakykite maistą ir gėrimą savo sėdimai vietai!',
    products_sidebar_textBeforeLink: 'Jei dar neturite bilieto, žiūrėkite mūsų ',
    products_sidebar_linkText: 'kino repertuarą',
    products_sidebar_textAfterLink: '.',
    eventSelection_chooseEventTitle: 'Pasirinkite įsigyto bilieto seansą',
    eventSelection_chooseSeatTitle: 'Pasirinkite įsigyto bilieto sėdimą vietą',
    eventSelection_chooseProduction: 'Pasirinkite filmą',
    eventSelection_chooseEvent: 'Pasirinkite seansą',
    eventSelection_chooseRow: 'Pasirinkite eilę',
    eventSelection_chooseSeat: 'Pasirinkite vietą',
    eventSelection_noNumberedSeats:
        'Šiame seanse nėra numeruotų vietų. Užsakyti produktai bus susieti su užsakovo vardu.',
    row: 'Eilė',
    seat: 'Vieta',
    cartEmpty: 'Krepšelis tuščias. Norėdami pateikti užsakymą, pridėkite produktą į krepšelį.',
}

// Map of all available languages
const languages: Record<string, LangStrings> = {
    et: etLang,
    lv: lvLang,
    en: enLang,
    fi: fiLang,
    lt: ltLang,
}

export const shouldUseLV = (): boolean => {
    // Check if domain ends with .lv
    const hostname = window.location.hostname
    return hostname.endsWith('.lv')
}

export const shouldUseET = (): boolean => {
    // Check if domain ends with .ee
    const hostname = window.location.hostname
    return hostname.endsWith('.ee')
}

export const shouldUseFI = (): boolean => {
    // Check if domain ends with .fi
    const hostname = window.location.hostname
    return hostname.endsWith('.fi')
}

export const shouldUseLT = (): boolean => {
    // Check if domain ends with .lt
    const hostname = window.location.hostname
    return hostname.endsWith('.lt')
}

// Use via state, not directly.
export const getLang = (): LangStrings => {
    if (shouldUseLV()) {
        return languages.lv
    }

    if (shouldUseET()) {
        return languages.et
    }

    if (shouldUseFI()) {
        return languages.fi
    }

    if (shouldUseLT()) {
        return languages.lt
    }

    // Default to Estonian if no specific domain match
    return languages.et
}

// Get language by code - useful for the selectedLang parameter
export const getLangByCode = (langCode: string): LangStrings => {
    return languages[langCode] || languages.et
}
